import { Directive, ElementRef, Renderer2, Input, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[setelementautofocus]'
})
export class SetAutofocusDirective implements AfterViewInit {
    private _autofocus: boolean;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit() {
        if (this._autofocus || typeof this._autofocus === 'undefined') {
            // ✅ Correct way in Angular 9+
            this.renderer.selectRootElement(this.el.nativeElement).focus();
        }
    }

    @Input() set setelementautofocus(condition: boolean) {
        this._autofocus = condition !== false;
    }
}